import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamQuestionAttemptSchema } from './schemas';

export const LEGACY_EXAM_QUESTION_ATTEMPT_FIELDS = describeFields(LegacyExamQuestionAttemptSchema, {
  marksBreakdown: { options: [] },
  markerId: {},
  markedDatetime: {},
  creationDatetime: {},
  outcome: { widget: FieldWidget.Text },
  mark: { widget: FieldWidget.Text },
  maxMark: { widget: FieldWidget.Text },
  examLabel: {},
  questionLabel: {},
  inaccuracyMarks: { widget: FieldWidget.Text },
  sillyMarks: { widget: FieldWidget.Text },
});
